import React from "react";
import { Form, Input } from "antd";
import { DealManagerComponentModalProps } from "..";
import { getDigitsOnly } from "../../../utils";

const PartnerModal: React.FC<DealManagerComponentModalProps> = ({ form }) => {
	return (
		<>
			{/* <Form.Item
				label="ID"
				name="id"
				rules={[
					{ required: true, message: "Please input the ID!" },
				]}
			>
				<Input disabled onChange={e => form.setFieldValue("id", getDigitsOnly(e.target.value))} />
			</Form.Item> */}
			<Form.Item
				label="Name"
				name="name"
				rules={[{ required: true, message: "Please input the name!" }]}
			>
				<Input />
			</Form.Item>
		</>
	);
};

export default PartnerModal;
